import React from 'react';
import moment from 'moment';

export const dateParser = {
    parse: (rule, relativeDate) => {
        relativeDate = moment(relativeDate) || moment();

        //parsing monthly date for the current month
        if (rule.monthly) {
            if (rule.numberOfDayOfWeek > 0) {
                const first = relativeDate.startOf('month').day();
                return relativeDate
                        .startOf('month')
                        .day(rule.dayOfWeek + ((first > rule.dayOfWeek) ? 7 : 0))
                        .add((rule.numberOfDayOfWeek - 1) * 7, 'days')
                        // .locale('ru')
                        // .format('DD.MM.YYYY');
            }
            else {
                const lastDayOfWeek = relativeDate.endOf('month').day();
                return relativeDate
                        .endOf('month')
                        .day(rule.dayOfWeek - ((lastDayOfWeek < rule.dayOfWeek) ? 7 : 0))
                        .add((-rule.numberOfDayOfWeek - 1) * 7, 'days')
                        // .locale('ru')
                        // .format('DD.MM.YYYY');
            }
        }
    }
}